module.exports = __webpack_public_path__ + "static/rc-5-bd6fdaa05c97fadd7fc4e9c37b684793.jpg";